import { useState, useEffect, FC } from 'react';

import NFTCard from '../components/NFTCard';
import { cardsLib } from '../services/cardsLib';
import { CardItem } from '../types';

import logoPNG from '../img/logo-big-blackBG.png';
import shape4PNG from '../img/shape4.png';
import shape5PNG from '../img/shape5.png';
import shape6PNG from '../img/shape6.png';

const Home: FC = () => {
  const [cards, setCards] = useState<CardItem[]>([]);

  useEffect(() => {
    setCards([
      cardsLib[2],
      cardsLib[8],
      { name: "Strong Boss — ?", cat: 9, tier: 4, img: shape4PNG, desc: "Mystery" },
      { name: "Epic Boss — ?", cat: 9, tier: 5, img: shape5PNG, desc: "Mystery" },
      { name: "Legendary Boss — ?", cat: 9, tier: 6, img: shape6PNG, desc: "Mystery" },
    ]);
  }, []);

  return (
    <div>
      {/* Hero section */}
      <section className="pt-7 pb-5 landing-bg text-white overflow-hidden">
        <div className="container py-4">
          <div className="row">
            <div className="col-md-10 col-xl-8 text-center mx-auto">
              <div className="d-block my-4">
                <img src={logoPNG} className="home-logo" alt="Prison Bears Logo" />
                <h1 className="display-4 fw-bold mb-3 text-white">NFT Game on Solana</h1>
                <div className="my-4 py-3" style={{ background: 'rgba(255, 193, 7, 0.15)', borderRadius: '12px', border: '1px solid rgba(255, 193, 7, 0.4)' }}>
                  <h2 className="fw-bold mb-2" style={{ color: '#ffc107' }}>Under Construction</h2>
                  <p className="lead mb-0 text-white-50">We are building something great. Stay tuned for the launch!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features section */}
      <section className="py-6 bg-white">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Game Features</h2>
            <p className="text-muted">A fully on-chain NFT game with deep mechanics and real token rewards</p>
          </div>

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Plinko Games</h5>
                  <p className="card-text text-muted">
                    Play across 3 levels of Plinko. Spend YEAR, CRIME, or RESPECT tokens to drop balls and win rewards.
                    Higher levels offer bigger multipliers and rarer boss drops.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Boss NFTs</h5>
                  <p className="card-text text-muted">
                    Collect Boss bears across 6 tiers and 5 categories. Each category has unique utility:
                    Collectibles, Airdrops, Power staking, Yield boosting, and rare Jackpot bosses.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Upgrade System</h5>
                  <p className="card-text text-muted">
                    Combine 4 bosses of the same tier to upgrade to a higher tier with a random category.
                    Higher tiers provide exponentially stronger abilities.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Staking & Airdrops</h5>
                  <p className="card-text text-muted">
                    Stake Power bosses to earn a share of 0.8 YEAR per block. Airdrop bosses
                    let you claim free YEAR tokens daily. Higher tier bosses earn more.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">NFT Marketplace</h5>
                  <p className="card-text text-muted">
                    Trade Boss NFTs with other players on the built-in marketplace.
                    List your bosses for sale, browse listings, and build your collection through trading.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">5 Game Tokens</h5>
                  <p className="card-text text-muted">
                    A rich token economy with YEAR, CRIME, RESPECT, GRUNT, and BRIBE tokens.
                    Each token serves a different purpose in the game ecosystem and can be swapped for USDT.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NFT showcase */}
      <section className="py-6">
        <div className="container home-nft-container">
          <div className="mb-4 text-center">
            <h2>Collect and Use</h2>
            <p className="text-muted">Collect different tiers and categories of NFTs. Bosses can be upgraded and used in game.</p>
          </div>

          <div className="row">
            {cards.map((card, index) => (
              <div className="nft-card" key={index}>
                <div className="card">
                  <NFTCard card={card} />
                  <div className="card-header">
                    <h5 className="card-title mb-0">{card.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom section */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h3 className="fw-bold mb-3">Coming Soon to Solana Mainnet</h3>
          <p className="text-muted mb-0">Follow our updates for launch announcements</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
